'use client'

import { useEffect } from 'react'

import {
  GoogleTagManagerEvent,
  useGoogleTagManagerTrack,
} from '@marketplace-web/google-track/google-track-feature'
import { ItemDetailsSidebarSectionResp } from '@marketplace-web/item-page/item-page-data'

type Props = {
  item: ItemDetailsSidebarSectionResp
  children: React.ReactNode
}

const SidebarContentWrapper = ({ item, children }: Props) => {
  const { googleTagManagerTrack } = useGoogleTagManagerTrack()

  useEffect(() => {
    const value = parseFloat(item.price.amount)
    googleTagManagerTrack(GoogleTagManagerEvent.ItemView, {
      item_name: item.title,
      item_id: item.id,
      value,
      currency: item.price.currency_code,
      item_category_id: item.catalog_id,
      item_brand: item.brand_dto?.title,
      item_brand_id: item.brand_dto?.id,
      item_condition: 4,
    })
  }, [googleTagManagerTrack, item])

  return children
}

export default SidebarContentWrapper
